import styles from './NoteID.module.scss';
import toast from 'react-hot-toast';

export interface NoteIDProps {
  noteId: string;
}

const NoteID = ({ noteId }: NoteIDProps) => {
  const copyNoteId = async () => {
    await navigator.clipboard.writeText(noteId);
    toast.success('Note ID copied to clipboard');
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLButtonElement>) => {
    if (event.key === 'Enter' || event.key === ' ') {
      copyNoteId().catch(console.log);
    }
  };

  return (
    <div className={styles.note_id__container}>
      <button
        className={styles.note_id__text}
        onClick={() => {
          copyNoteId().catch(console.log);
        }}
        onKeyDown={handleKeyDown}
        title={`${noteId} (click to copy)`}
      >
        Note ID
      </button>
    </div>
  );
};

export default NoteID;
